import './App.css';
import MainJS from "./components/MainJS";

function App() {
  return (
    <div className="App">
      <MainJS/>
    </div>
  );
}

export default App;
